import { render, staticRenderFns } from "./settings-qunfa.vue?vue&type=template&id=098f9bc2&scoped=true&"
import script from "./settings-qunfa.vue?vue&type=script&lang=js&"
export * from "./settings-qunfa.vue?vue&type=script&lang=js&"
import style0 from "./settings-qunfa.vue?vue&type=style&index=0&id=098f9bc2&lang=scss&scoped=true&"
import style1 from "./settings-qunfa.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f9bc2",
  null
  
)

export default component.exports